import {
    Component,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';
import { Router } from '@angular/router';
import { ProviderContext } from '../../data/Entities';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { setTimeout } from 'timers';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Helpers } from '../../services/Helpers';

declare var jQuery: any;

@Component({
    selector: 'orderlist',
    templateUrl: '/templates/get/Order/order_list',
})
export class OrderList implements OnInit {
    public current_row: any;
    public groupActionVisible: boolean;
    public groupAction: string;
    public action: string;
    public dtx: ProviderContext;
    public rows: any = [];
    public setStatusID: string;

    public collectingEmailAddress: string;
    public delivery90min: boolean;
    public deliverytoday: boolean;

    public filterStatusID: string;
    public filterDeliveryTypeID: string;
    public filterCreated: string;
    public filterGen: string;

    constructor(
        public siteServices: SiteServices,
        private modalService: BsModalService,
        public viewRef: ViewContainerRef,
        private router: Router,
        private http: HttpClient
    ) {
        this.dtx = new ProviderContext({
            ProviderCode: 'ORDER',
            SortField: 'OrderID',
            IsAsc: false,
        });

        this.refresh(true);

        this.siteServices.provider_GetDataByID(
            'SETTINGS',
            'IsDelivery90Min',
            null,
            (data) => {
                this.delivery90min = data.TagObject.Value == '1' ? true : false;
            }
        );

        this.siteServices.provider_GetDataByID(
            'SETTINGS',
            'IsDeliveryToday',
            null,
            (data) => {
                this.deliverytoday = data.TagObject.Value == '1' ? true : false;
            }
        );
    }

    public ngOnInit() {
        this.siteServices.onChangeDetail.subscribe((order) => {
            if (!order) return;
            let order2 = order;

            var c = new ProviderContext({
                ProviderCode: 'ORDER',
            });
            c.addFilter('OrderID', order.OrderID);
            this.siteServices.provider_GetPage(c, (data) => {
                order2 = data.TagObject[0];

                let dx = Helpers.findKeyNdx(
                    this.rows,
                    order2.OrderID,
                    'OrderID'
                );
                if (dx >= 0) {
                    this.rows[dx] = order2;
                } else this.rows.splice(0, 0, order2);
            });
        });
    }

    public refresh(needCount: boolean) {
        this.rows = [];
        this.groupActionVisible = false;
        this.groupAction = null;

        this.siteServices.provider_GetPage(this.dtx, (data) => {
            this.rows = data.TagObject;
            this.dtx.TotalItems = data.Tag;
        });
    }

    public pageChanged(ev) {
        this.dtx.Page = ev.page;
        this.refresh(false);
    }

    public onSort(_sortField) {
        if (this.dtx.SortField === _sortField) {
            this.dtx.IsAsc = !this.dtx.IsAsc;
        } else {
            this.dtx.SortField = _sortField;
            this.dtx.IsAsc = true;
        }
        this.refresh(false);
    }

    public onSortChange($ev) {
        //console.log($ev);
        const arr = $ev.target.value.split(' ');
        this.dtx.SortField = arr[0];
        this.dtx.IsAsc = arr.length === 1;

        this.dtx.SortField2 = arr[2];
        this.dtx.IsAsc2 = arr.length === 1;

        //console.log(this.dtx);
        // this.refresh(false);
    }

    public edit(id) {
        this.router
            .navigate(['orderdetail', id, Helpers.GetTicks()])
            .then((_ev) => {});
    }

    public doToggleSelect(prod: any, ev: any) {
        prod._selected = ev.target.checked;

        this.groupActionVisible =
            this.rows.filter((x) => x._selected).length > 0;
        if (!this.groupActionVisible) {
            this.groupAction = null;
        }
    }

    public toggleAll(ev: any) {
        for (const p of this.rows) {
            p._selected = ev.target.checked;
        }

        this.groupActionVisible =
            this.rows.filter((x) => x._selected).length > 0;
        if (!this.groupActionVisible) {
            this.groupAction = null;
        }
    }

    getSeletedItems() {
        return this.rows
            .filter((x) => x._selected)
            .map((y) => {
                return y.OrderID;
            });
    }

    public setGroupStatus() {
        const arr = this.getSeletedItems();

        this.siteServices.provider_Execute(
            'ORDER',
            'SETSTATUS',
            { orderArr: arr, targetStatusID: this.setStatusID },
            (data) => {
                this.refresh(true);
                setTimeout((x) => {
                    this.siteServices.success(
                        'Beállítás OK -' + arr.length + ' db.'
                    );
                }, 500);
            }
        );
    }

    public doSendCollectingEmail() {
        const arr = this.getSeletedItems();

        this.siteServices.provider_Execute(
            'ORDER',
            'SENDCOLLECTINGEMAIL',
            {
                orderArr: arr,
                collectingEmailAddress: this.collectingEmailAddress,
            },
            (data) => {
                this.refresh(true);
                setTimeout((x) => {
                    this.siteServices.success(
                        'Beállítás OK -' + arr.length + ' db.'
                    );
                }, 500);
            }
        );
    }

    public toggledelivery90min() {
        this.delivery90min = !this.delivery90min;

        this.siteServices.provider_Save(
            'SETTINGS',
            { Key: 'IsDelivery90Min', Value: this.delivery90min ? '1' : '0' },
            (data) => {
                this.siteServices.success('OK');
            }
        );
    }

    public toggledeliverytoday() {
        this.deliverytoday = !this.deliverytoday;

        this.siteServices.provider_Save(
            'SETTINGS',
            { Key: 'IsDeliveryToday', Value: this.deliverytoday ? '1' : '0' },
            (data) => {
                this.siteServices.success('OK');
            }
        );
    }

    public doFilter() {
        this.dtx.FilterList = [];
        if (this.filterStatusID)
            this.dtx.addFilter('StatusID', this.filterStatusID);
        if (this.filterDeliveryTypeID)
            this.dtx.addFilter('DeliveryTypeID', this.filterDeliveryTypeID);
        if (this.filterCreated)
            this.dtx.addFilter('Created', this.filterCreated);
        if (this.filterGen) this.dtx.addFilter('Gen', this.filterGen);

        this.refresh(true);
    }
}
